import { BeltColor } from "@kamae-apps/shared/Types/Belt/BeltColor"
import { CompanyStatus } from "@kamae-apps/shared/Types/Company/CompanyStatus"
import { formatInTimeZone } from "date-fns-tz"

const beltLevelMap = new Map<BeltColor, number>([
  [BeltColor.white, 5],
  [BeltColor.yellow, 11],
  [BeltColor.orange, 16],
  [BeltColor.green, 20],
  [BeltColor.blue, 24],
  [BeltColor.purple, 27],
  [BeltColor.brown, 31],
  [BeltColor.black, 34],
  [BeltColor.red, 37],
  [BeltColor.bronze, 39],
  [BeltColor.silver, 42],
  [BeltColor.gold, 44],
  [BeltColor.god, 10000],
])

export function getNextLevel(belt: BeltColor) {
  return beltLevelMap.get(belt) ?? 5
}

export function formatDate(date: Date, displayHours = true, displaySeconds = false): string {
  const lang = localStorage.getItem("lang") ?? "fr"
  if (lang !== "en") {
    return formatInTimeZone(
      date,
      "Europe/Paris",
      `dd/MM/yyyy ${displayHours ? `HH:mm${displaySeconds ? ":ss" : ""}` : ""}`
    )
  }
  return formatInTimeZone(
    date,
    "Europe/Paris",
    `MM/dd/yyyy ${displayHours ? `hh:mm${displaySeconds ? ":ss" : ""} aaa` : ""}`
  )
}

export function isNil(value: unknown): boolean {
  return value === null || value === undefined
}

export function isBlank(value: string): boolean {
  return value.trim() === ""
}

export function isNilOrBlank(value: unknown): boolean {
  return isNil(value) || (typeof value === "string" && isBlank(value))
}

export function validateEmail(email: string): boolean {
  return /^[\w\d.'-]+@[\w\d.-]+\.[\w\d_-]{2,}$/.test(email)
}

const codeToLang = new Map<number, string>([
  [1, "fr"],
  [2, "en"],
  [3, "es"],
  [4, "de"],
  [5, "pt"],
  [6, "it"],
])

export function fromCodeToLang(code: number): string {
  return codeToLang.get(code) ?? "fr"
}

// Hash a string using SHA-1
export async function sha1(message: string) {
  const msgUint8 = new TextEncoder().encode(message)
  const hashBuffer = await crypto.subtle.digest("SHA-1", msgUint8)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("")
}

export function shouldThePathBeMemoized(path: string) {
  return path !== "/" && path !== "/login"
}

export const getCompanyPlan = (companyStatus: CompanyStatus): string => {
  switch (companyStatus) {
    case CompanyStatus.Customer:
      return "Essential"
    case CompanyStatus.Starter:
      return "Starter"
    case CompanyStatus.Trial:
      return "Trial"
    case CompanyStatus.Kamae:
      return "Kamae"
    case CompanyStatus.Churned:
      return "Churned"
    default:
      return "Unknown"
  }
}

export const secondsToMinSec = (timerSecond: number): string => {
  const seconds = Math.max(0, Math.floor(timerSecond))
  const minutes = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${minutes}:${String(secs).padStart(2, "0")}`
}
